import { v4 } from 'uuid';

// see also useUuid in src/hooks/useUuid.ts

export const UuidRegex =
	/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

export const getUuid = v4;
